import VueRouter from 'vue-router'

declare global {
  interface Window {
    newrelic?: {
      addPageAction: (name: string, attributes?: Record<string, any>) => void
    }
  }
}

/**
 * Reports each navigation to New Relic Browser as a PageAction.
 * This app uses Vue Router in hash mode, so the agent's automatic
 * SPA route tracking never sees the route change on its own.
 */
export function trackRouteChanges(router: VueRouter, appName: string) {
  router.afterEach((to) => {
    if (!window.newrelic) return

    window.newrelic.addPageAction('routeChange', {
      app: appName,
      routeName: to.name || null,
      routePath: to.path,
    })
  })
}
